"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitmovinPlayer = void 0;
var tslib_1 = require("tslib");
var bitmovin_player_ui_1 = require("bitmovin-player-ui");
var bitmovinplayer_core_1 = require("bitmovin-player/modules/bitmovinplayer-core");
var bitmovinplayer_polyfill_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-polyfill"));
var bitmovinplayer_engine_bitmovin_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-engine-bitmovin"));
var bitmovinplayer_container_mp4_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-container-mp4"));
var bitmovinplayer_mserenderer_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-mserenderer"));
var bitmovinplayer_abr_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-abr"));
var bitmovinplayer_drm_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-drm"));
var bitmovinplayer_xml_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-xml"));
var bitmovinplayer_dash_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-dash"));
var bitmovinplayer_crypto_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-crypto"));
var bitmovinplayer_tizen_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-tizen"));
var bitmovinplayer_webos_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-webos"));
var bitmovinplayer_style_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-style"));
var bitmovinplayer_hls_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-hls"));
var bitmovinplayer_container_ts_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-container-ts"));
var bitmovinplayer_subtitles_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-subtitles"));
var bitmovinplayer_subtitles_cea608_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-subtitles-cea608"));
var bitmovinplayer_subtitles_native_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-subtitles-native"));
var bitmovinplayer_subtitles_ttml_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-subtitles-ttml"));
var bitmovinplayer_subtitles_vtt_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-subtitles-vtt"));
var bitmovinplayer_advertising_core_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-advertising-core"));
var bitmovinplayer_advertising_ima_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-advertising-ima"));
var bitmovinplayer_advertising_omsdk_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-advertising-omsdk"));
var bitmovinplayer_analytics_1 = tslib_1.__importDefault(require("bitmovin-player/modules/bitmovinplayer-analytics"));
require("bitmovin-player-ui/dist/css/bitmovinplayer-ui.css");
var enums_1 = require("../../../enums");
var utils_1 = require("../../../utils/utils");
var constants_1 = require("../../../constants/constants");
var BitmovinPlayer = /** @class */ (function () {
    function BitmovinPlayer(config, appConfig, videoInfo, analyticsConfig) {
        this.playerInstance = null;
        this.playerUiInstance = null;
        this.config = config;
        this.appConfig = appConfig;
        this.videoInfo = videoInfo;
        this.analyticsConfig = analyticsConfig;
    }
    BitmovinPlayer.prototype.initialize = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a, _b;
            var bitmovinPlayer = _this.appConfig.video_player.vendor_name === enums_1.PlayerType.BITMOVIN;
            var enabledPlayer = _this.appConfig.video_player.enable;
            var showControls = _this.appConfig.video_player.otherValues.controls;
            var _c = _this.videoInfo || {}, streamUrls = _c.streamUrls, drmConfigs = _c.drmConfigs;
            var streamUrlsParsed = (0, utils_1.reduceUrlByType)(streamUrls);
            var DRMConfigsParsed = (0, utils_1.reduceUrlByType)(drmConfigs, true);
            var videoUrl = streamUrls === null || streamUrls === void 0 ? void 0 : streamUrls[0];
            var sourceConfigParsed = {
                dash: (streamUrlsParsed === null || streamUrlsParsed === void 0 ? void 0 : streamUrlsParsed.dash) || '',
                hls: (streamUrlsParsed === null || streamUrlsParsed === void 0 ? void 0 : streamUrlsParsed.hls) || '',
                progressive: (streamUrlsParsed === null || streamUrlsParsed === void 0 ? void 0 : streamUrlsParsed.progressive) || '',
                drm: DRMConfigsParsed,
                poster: videoUrl ? _this.videoInfo.contextData.Thumbnail : '',
            };
            if (bitmovinPlayer && enabledPlayer) {
                var container = document.getElementById(_this.config.playerContainerId);
                // TODO: Explore which modules we need for TV or WEB
                // Maybe we don't need some of the modules at all
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_engine_bitmovin_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_mserenderer_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_xml_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_dash_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_drm_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_abr_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_container_mp4_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_polyfill_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_style_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_crypto_1.default);
                // TODO: Investigate if we can import the module if Platform is TV
                // Because this way it is imported for WEB as well.
                // FROM BUILD_CONFIG
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_tizen_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_webos_1.default);
                //
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_subtitles_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_subtitles_cea608_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_container_ts_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_hls_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_subtitles_native_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_subtitles_vtt_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_subtitles_ttml_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_advertising_core_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_advertising_ima_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_advertising_omsdk_1.default);
                bitmovinplayer_core_1.Player.addModule(bitmovinplayer_analytics_1.default);
                var reduceAdsConfig = function (adsConfig) {
                    return adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.map(function (_a) {
                        var id = _a.id, position = _a.position, title = _a.title, type = _a.type, url = _a.url;
                        return ({
                            id: id,
                            position: position,
                            title: title,
                            tag: { type: type, url: url },
                        });
                    });
                };
                var adBreaks = reduceAdsConfig(_this.videoInfo.adsConfig);
                var advertising = { adBreaks: adBreaks };
                var newConfig = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, _this.config), { key: (_a = _this.config.key) !== null && _a !== void 0 ? _a : constants_1.playerDefaultKey, advertising: advertising }), (_this.analyticsConfig && {
                    analytics: {
                        key: _this.analyticsConfig.API_KEY,
                        videoId: _this.videoInfo.id,
                        title: _this.videoInfo.title,
                    },
                }));
                _this.playerInstance = container && new bitmovinplayer_core_1.Player(container, newConfig);
                if (showControls) {
                    _this.playerUiInstance = _this.playerInstance && bitmovin_player_ui_1.UIFactory.buildUI(_this.playerInstance);
                }
                _this.playerReadyPromise = new Promise(function (resolve) {
                    var _a;
                    _this.playerIsReadyListener = function () {
                        if (_this.playerInstance) {
                            _this.videoDuration = _this.playerInstance.getDuration();
                            resolve(true);
                        }
                    };
                    (_a = _this.playerInstance) === null || _a === void 0 ? void 0 : _a.on(bitmovinplayer_core_1.PlayerEvent.SourceLoaded, _this.playerIsReadyListener);
                });
                (_b = _this.playerInstance) === null || _b === void 0 ? void 0 : _b.load(sourceConfigParsed).then(function () {
                    console.log('Successfully loaded source');
                    resolve(true);
                }, function (err) {
                    console.error('Error loading source', err);
                    reject(false);
                });
            }
            else {
                resolve(false);
            }
        });
    };
    BitmovinPlayer.prototype.destroy = function () {
        var _this = this;
        if (this.playerInstance) {
            this.playerUiInstance && this.playerUiInstance.release();
            this.playerInstance.off(bitmovinplayer_core_1.PlayerEvent.SourceLoaded, this.playerIsReadyListener);
            this.playerInstance.destroy().then(function () {
                _this.playerInstance = null;
            });
        }
        else {
            console.error('Bitmovin player is not initialized. Call initialize() first.');
        }
    };
    BitmovinPlayer.prototype.play = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.playerInstance) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.playerReadyPromise];
                    case 1:
                        _a.sent();
                        this.playerInstance.play();
                        return [3 /*break*/, 3];
                    case 2:
                        console.error('Bitmovin player is not initialized. Call initialize() first.');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BitmovinPlayer.prototype.pause = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.playerInstance) {
                    this.playerInstance.pause();
                }
                else {
                    console.error('Bitmovin player is not initialized. Call initialize() first.');
                }
                return [2 /*return*/];
            });
        });
    };
    BitmovinPlayer.prototype.seek = function (time) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.playerInstance) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.playerReadyPromise];
                    case 1:
                        _a.sent();
                        this.playerInstance.seek(time);
                        return [3 /*break*/, 3];
                    case 2:
                        console.error('Bitmovin player is not initialized. Call initialize() first.');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BitmovinPlayer.prototype.getCurrentTime = function () {
        if (this.playerInstance) {
            return this.playerInstance.getCurrentTime();
        }
        else {
            console.error('Bitmovin player is not initialized. Call initialize() first.');
            return 0;
        }
    };
    BitmovinPlayer.prototype.getDuration = function () {
        if (this.playerInstance && this.videoDuration) {
            return this.videoDuration;
        }
        else {
            console.error('Bitmovin player is not initialized. Call initialize() first.');
            return 0;
        }
    };
    BitmovinPlayer.prototype.getVideoElement = function () {
        if (this.playerInstance) {
            return this.playerInstance.getVideoElement();
        }
        else {
            console.error('Bitmovin player is not initialized. Call initialize() first.');
            return null;
        }
    };
    BitmovinPlayer.prototype.isLive = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.playerInstance) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.playerReadyPromise];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.playerInstance.isLive()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        console.error('Error in isLive(). Player is not initialized');
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BitmovinPlayer.prototype.on = function (eventType, callback) {
        if (this.playerInstance) {
            return this.playerInstance.on(eventType, callback);
        }
        else {
            console.error('Error in player event "on". Player is not initialized');
        }
    };
    BitmovinPlayer.prototype.isInitialized = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.playerInstance) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.playerReadyPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        console.error('Error in isInitialized()');
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BitmovinPlayer.prototype.getSubtitleList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.playerInstance) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.playerReadyPromise];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.playerInstance.subtitles.list()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        console.error('Error in getSubtitleList(). Player is not initialized');
                        return [2 /*return*/, []];
                }
            });
        });
    };
    BitmovinPlayer.prototype.getAudioList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.playerInstance) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.playerReadyPromise];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.playerInstance.getAvailableAudio()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        console.error('Error in getAudioList(). Player is not initialized');
                        return [2 /*return*/, []];
                }
            });
        });
    };
    BitmovinPlayer.prototype.getAudio = function () {
        if (this.playerInstance) {
            return this.playerInstance.getAudio();
        }
        else {
            console.error('Error in getAudio(). Player is not initialized');
            return null;
        }
    };
    BitmovinPlayer.prototype.setAudio = function (audioId) {
        if (this.playerInstance) {
            return this.playerInstance.setAudio(audioId);
        }
        else {
            console.error('Error in setAudio(). Player is not initialized');
        }
    };
    return BitmovinPlayer;
}());
exports.BitmovinPlayer = BitmovinPlayer;
